{
  "salon-details-page": {
    "buttons": {
      "next": "TIẾP"
    },
    "meta": {
      "description": "Đến thăm tiệm {{salon}} - {{address}}, đặt lịch trực tuyến 24/7 và săn các chương trình khuyến mãi"
    }
  }
}
